import axios from '../../_utils/axios';

// ----------------------------------------------------------------------

const createSpecimens = async (data) => {
  return await axios.post('specimens', data)
    .catch((error) => {
      return Promise.reject(error);
    });
};

export default createSpecimens;